module.exports = __webpack_public_path__ + "c_static/img/我的淘宝+淘气值.1687296.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/截图示范/我的淘宝+淘气值.jpg
// module id = 4TwL
// module chunks = 33